import { Injectable, TemplateRef } from '@angular/core';
import { Workbook } from 'exceljs';
import { HttpClient } from '@angular/common/http';
// import * as jsPDF from 'jspdf';
// import 'jspdf-autotable';

declare var jsPDF;

export enum ColumnDatatype {
    STRING = 'string',
    NUMBER = 'number',
    TEMPORAL = 'temporal',
    BOOLEAN = 'boolean',
    ENUM = 'enum',
    CUSTOM = 'custom'
}
export enum HorizontalCellAlign {
    LEFT = 'left',
    RIGHT = 'right',
    CENTER = 'center'
}
export enum VerticalCellAlign {
    TOP = 'top',
    MIDDLE = 'middle',
    BOTTOM = 'bottom'
}

export interface ColumnDef {
    field: string,
    header: string,
    datatype?: ColumnDatatype,
    enum?: any[],
    width?: number,
    hidden?: boolean,
    horizontal?: HorizontalCellAlign,
    vertical?: VerticalCellAlign,

    template?: TemplateRef<any>
}

export interface FilterColumnDef {
    field_name?: string,
    field_value?: string
}


@Injectable()
export class ExportProvider {

    // private dejaVuSans: string;

    constructor(private http: HttpClient) {
        // this.getFontBase64('DejaVuSans.ttf')
        // .then(str => this.dejaVuSans = str);
    }

    downloadPDF(data: any[], columns: ColumnDef[], title: string) {

        if (!data || !data.length) return;
        if (!columns || !columns.length) return;
        // if (!this.dejaVuSans) return;

        let _cols = [];
        for (let col of columns) {
            _cols.push({ header: col.header, dataKey: col.field });
        }

        let rows: any[] = [];
        data.forEach(item => {
            //   let row = 
            let row: string[] = [];
            columns.forEach((col) => {
                let str: string = this.getDisplay(item[col.field], col.datatype);
                // if (!col.datatype || col.datatype == 'string') {
                //     str = this.stripTashkeel( str ) || '';
                // } else if (col.datatype == 'boolean') {
                //     str = item[col.field]? 'Yes' : '';
                // } else if (col.datatype == 'enum') {
                //     str = (item[col.field])? item[col.field].name || '' : '';
                // }
                // let str = (!col.datatype || col.datatype == 'string')? this.stripTashkeel( item[col.field] ) : item[col.field];
                row.push(str);    // || '';
            });
            rows.push(row);
        })

        title = this.stripTashkeel(title);

        const doc = new jsPDF();
        doc.setLanguage('ar');
        // 
        // jsPDF.addFileToVFS('DejaVuSans-normal.ttf', this.dejaVuSans);
        // jsPDF.addFile
        // doc.addFileToVFS('DejaVuSans-normal.ttf', this.dejaVuSans);
        // doc.addFont('DejaVuSans-normal.ttf', 'DejaVuSans', 'normal');

        let all_fonts = doc.getFontList();
        // console.log(all_fonts);
        // ) {
        //     console.log(font);
        // }

        // doc.setFont('DejaVuSans');
        doc.setFont('DejaVuSans');
        doc.setFontStyle('bold');
        doc.setFontSize(16);

        // doc.text(title, 20, 20);

        let midline = doc.internal.pageSize.getWidth() / 2;
        doc.text(midline, 20, '- ' + title + ' -', { align: 'center', lang: 'ar' });
        // doc.text(title, midline, 10, {align: 'center'});

        // doc.text(title, doc.internal.pageSize.getWidth(), 50, null, null, 'center');

        // doc.addFileToVFS('yourCustomFont.ttf', 'yourCustomFontTtfBase64Encoded');
        // doc.addFont('yourCustomFont.ttf', 'yourCustomFont', 'normal');
        // doc.setFont('yourCustomFont');

        doc.autoTable({
            columns: _cols, body: rows, theme: 'striped',
            startY: 28,
            bodyStyles: { font: 'DejaVuSans', fontStyle: 'normal' },
            headStyles: { font: 'DejaVuSans', fontStyle: 'bold' }
        });

        // autoTable(doc, { columns: fields, body : rows, theme: 'striped'});
        // doc.autoTable(this.cols, this.data);
        doc.save(title + new Date().getTime() + '.pdf');

        // const header = ["Year", "Month", "Make", "Model", "Quantity", "Pct"]

        /*data.forEach(item => {
        //   let row = 
            let row: string[] = [];
            fields.forEach((f) => row.push(item[f]) || '' );
            worksheet.addRow(row);
        }
        );
        
        doc.output('UInt8Array').then((pdfBuffer: any) => {
            let filename = title + ' ' + new Date().getTime() + '.xlsx';
            let mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            this.writeContents(pdfBuffer, filename, mimeType);
            //   let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            //   fs.saveAs(blob, 'CarData.xlsx');
        })*/
    }

    downloadExcel(data: any[], columns: ColumnDef[], title: string, disableWrapText?: boolean, filterArr?: FilterColumnDef[]) {

        if (!data || !data.length) return;
        if (!columns || !columns.length) return;

        // const header = ["Year", "Month", "Make", "Model", "Quantity", "Pct"]

        //Create workbook and worksheet
        let workbook = new Workbook();
        let worksheet = workbook.addWorksheet(title);

        let enableWrapText = true;
        if (disableWrapText) {
            enableWrapText = false;
        }

        // let subTitleRow = worksheet.addRow(['Date : ' + this.datePipe.transform(new Date(), 'medium')])
        //Add Image
        // let logo = workbook.addImage({
        //   base64: logoFile.logoBase64,
        //   extension: 'png',
        // });
        // worksheet.addImage(logo, 'E1:F3');
        // worksheet.mergeCells('A1:D2');
        //Blank Row 
        // worksheet.addRow([]);
        //Add Header Row
        let headers = [];
        let fields = [];
        let i = 1;
        for (let col of columns) {
            worksheet.getColumn(i).key = col.field;
            // if (col.width > 0) {
            worksheet.getColumn(i).width = col.width || 14;
            // } else {
            //     worksheet.getColumn(i).width = 
            // }
            worksheet.getColumn(i).alignment = { wrapText: enableWrapText };
            if (col.horizontal) {
                worksheet.getColumn(i).alignment.horizontal = col.horizontal;
            }
            if (col.vertical) {
                worksheet.getColumn(i).alignment.vertical = col.vertical;
            }
            i += 1;

            headers.push(col.header);
            fields.push(col.field);
        }

        //Add Row and formatting
        if (title && title.trim().length) {
            let titleRow = worksheet.addRow([title]);
            titleRow.font = { name: 'Calibri', family: 4, size: 16, bold: true }
            // titleRow.alignment = {wrapText: true, horizontal: HorizontalCellAlign.CENTER }
            // for(let c = 1; c < columns.length; c++) {
            //     worksheet.getCell(1,c).alignment = {wrapText: true, horizontal: HorizontalCellAlign.CENTER }
            // }
            worksheet.mergeCells(1, 1, 1, columns.length);

            worksheet.getCell(1, 1).alignment = { wrapText: enableWrapText, horizontal: HorizontalCellAlign.CENTER }

            worksheet.addRow([]);
            // Add filter rows
            // Add filter rows
            if (filterArr) {
                for (let element of filterArr) {

                    // Create an empty row first
                    let row = worksheet.addRow([null]);

                    // Get row number
                    let rowNumber = row.number;

                    // Prepare rich text (bold field_name)
                    const cell = worksheet.getCell(rowNumber, 1);
                    cell.value = {
                        richText: [
                            { text: `${element.field_name}`, font: { bold: true } },
                            { text: ` : ${element.field_value}` }
                        ]
                    };

                    // Merge all columns in the row
                    worksheet.mergeCells(rowNumber, 1, rowNumber, columns.length);

                    // Alignment
                    cell.alignment = {
                        wrapText: enableWrapText,
                        horizontal: 'left'
                    };

                    // Optional font styling for the merged cell
                    cell.font = { name: 'Calibri', size: 12 };
                }
            }

        }

        let headerRow = worksheet.addRow(headers);

        // Cell Style : Fill and Border
        headerRow.eachCell((cell, number) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '00FFFFFF' },
                bgColor: { argb: 'FFE8E8E8' }
            }
            cell.border = { top: { style: 'thick' }, bottom: { style: 'thick' } }
        })
        // worksheet.addRows(data);
        // Add Data and Conditional Formatting
        data.forEach(item => {
            //   let row = 
            let row: string[] = [];
            columns.forEach((col) => {
                let str = this.getDisplay(item[col.field], col.datatype) || '';
                row.push(str);
            });
            worksheet.addRow(row);
            //   let qty = row.getCell(5);
            //   let color = 'FF000000';
            //   if (+qty.value < 500) {
            //     color = 'FF9999'
            //   }
            //   qty.fill = {
            //     type: 'pattern',
            //     pattern: 'solid',
            //     fgColor: { argb: color }
            //   }
        }
        );
        // worksheet.getColumn(3).width = 30;
        // worksheet.getColumn(4).width = 30;
        worksheet.addRow([]);

        //Footer Row
        /*
            let footerRow = worksheet.addRow(['This is system generated excel sheet.']);
            footerRow.getCell(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFCCFFE5' }
            };
            footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            //Merge Cells
            worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);
            //Generate Excel File with given name
        */

        workbook.xlsx.writeBuffer().then((excelBuffer: any) => {
            let filename = title + ' ' + new Date().getTime() + '.xlsx';
            let mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            this.writeContents(excelBuffer, filename, mimeType);
            //   let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            //   fs.saveAs(blob, 'CarData.xlsx');
        })
    }

    downloadDoc(content: string, styles: string, filename: string) {
        let css = (
            `<style>
        @page WordSection1{size: 1190pt 842pt;mso-page-orientation: landscape;}
        div.WordSection1 {page: WordSection1;}
        ${styles}
        </style>`
        );

        var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>" + css + "<head><meta charset='utf-8'></head><body>";
        var postHtml = "</body></html>";
        debugger;
        var html = preHtml + content + postHtml;

        var blob = new Blob(['\ufeff', html], {
            type: 'application/msword'
        });

        // Specify link url
        var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);

        // Specify file name
        filename = filename ? filename + '.doc' : 'document.doc';

        // Create download link element
        var downloadLink = document.createElement("a");

        document.body.appendChild(downloadLink);
        // @ts-ignore
        if (navigator.msSaveOrOpenBlob) {
            // @ts-ignore
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            // Create a link to the file
            downloadLink.href = url;

            // Setting the file name
            downloadLink.download = filename;

            //triggering the function
            downloadLink.click();
        }

        document.body.removeChild(downloadLink);
    }

    private getDisplay(value: any, datatype: string): string {
        let str: string;
        if (!datatype || datatype == ColumnDatatype.STRING) {
            str = this.stripTashkeel(value) || '';
        } else if (datatype == ColumnDatatype.NUMBER) {
            str = value ? value : '';
        } else if (datatype == ColumnDatatype.BOOLEAN) {
            str = value ? 'Yes' : '';
        } else if (datatype == ColumnDatatype.ENUM) {
            str = value ? value.name || '' : '';
        } else if (datatype == ColumnDatatype.CUSTOM) {
            str = this.stripTashkeel(value) || '';
        }
        return str;
    }

    private async getFontBase64(fontfile: string): Promise<string> {

        return await this.http.get('/assets/fonts/' + fontfile, { responseType: 'blob' })
            .toPromise()
            .then(res => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(res);
                    reader.onload = () => {
                        let str = (reader.result as string);
                        let pure = str.substr(str.indexOf('base64,') + 7);
                        resolve(pure);
                    }
                    reader.onerror = error => reject(error);
                })
            });
    }

    writeContents(content: Uint8Array, fileName: string, contentType: string) {
        const a = document.createElement('a');
        const file = new Blob([content], { type: contentType });
        a.href = URL.createObjectURL(file);
        a.download = fileName;
        a.click();
        a.remove();
        // document.removeChild(a);
    }

    private CHARCODE_SHADDA = 1617;
    private CHARCODE_SUKOON = 1618;
    private CHARCODE_SUPERSCRIPT_ALIF = 1648;
    private CHARCODE_TATWEEL = 1600;
    private CHARCODE_ALIF = 1575;
    private CHARCODE_ALLAH = 65010;

    isCharTashkeel(letter: string): boolean {
        if (typeof (letter) == "undefined" || letter == null)
            return false;

        var code = letter.charCodeAt(0);
        //1648 - superscript alif
        //1619 - madd: ~
        return (code == this.CHARCODE_TATWEEL || code == this.CHARCODE_SUPERSCRIPT_ALIF || code >= 1612 && code <= 1631); //tashkeel
    }

    replaceAllah(letter: string): string {
        if (typeof (letter) == "undefined" || letter == null)
            return '';

        var code = letter.charCodeAt(0);
        if (code == this.CHARCODE_ALLAH) return 'اللـه';
        return letter;
    }

    stripTashkeel(input: string) {
        if (!input || !input.replace) return input;

        input = input.replace('الله', 'اللـه');
        var output = "";
        //todo consider using a stringbuilder to improve performance
        for (var i = 0; i < input.length; i++) {
            var letter = input.charAt(i);
            if (!this.isCharTashkeel(letter)) //tashkeel
                letter = this.replaceAllah(letter);
            output += letter;
        }

        return output;
    }

}